<div class="nb-grid" #ref>
  <ag-grid-angular
    class="ag-theme-alpine"
    [icons]="gridIcons"
    [rowModelType]="rowModelType"
    [rowSelection]="options.enableMultiSelect ? 'multiple' : 'single'"
    [suppressRowClickSelection]="!options.enableFullRowSelection"
    [suppressContextMenu]="!options.enableRowContextMenu"
    [getContextMenuItems]="getContextMenuItems"
    [suppressColumnMoveAnimation]="!options.enableColumnAnimation"
    [animateRows]="options.enableRowAnimation"
    [enableCellTextSelection]="options.enableCellTextSelection"
    [enableBrowserTooltips]="options.enableBrowserTooltips"
    [columnDefs]="options.columnDefs"
    [immutableData]="options.immutableData"
    [getRowNodeId]="options.getRowNodeId"
    [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequest"
    [isRowSelectable]="options.isRowSelectable"
    [isExternalFilterPresent]="options.isExternalFilterPresent"
    [doesExternalFilterPass]="options.doesExternalFilterPass"
    [defaultColDef]="{ sortable: options.enableSorting, resizable: options.enableColumnResize }"
    (gridReady)="onGridReady($event)"
    (sortChanged)="onGridSort($event)"
    (filterChanged)="options.onFilterChanged($event)"
    (rowSelected)="options.onRowSelected($event)"
  >
  </ag-grid-angular>
</div>
